const services = [
  {
    icon: "ri-alarm-warning-line",
    title: "Emergency Passport — Casper",
    badge: "Fastest",
    description: "Life-or-death emergency? We prepare your complete packet and coordinate agency-level expedited processing — often within 24 hours.",
    bullets: ["Travel within 72 hours", "Complete document review", "Overnight shipping coordination", "Dedicated agent support"],
    link: "https://fastpassportcenter.com/checkout/",
  },
  {
    icon: "ri-refresh-line",
    title: "Passport Renewal — Casper",
    description: "Your Casper renewal handled start-to-finish. We check your eligibility, review your documents, and submit via registered courier.",
    bullets: ["Adults and children", "Mail-in or in-person options", "Expedited 2–9 day processing", "No guesswork or agency lines"],
    link: "https://fastpassportcenter.com/checkout/",
  },
  {
    icon: "ri-file-add-line",
    title: "New Passport Application",
    description: "First-time applicant in Casper? We walk you through every step, prepare your documents, and schedule your acceptance facility visit.",
    bullets: ["Step-by-step guidance", "Document checklist included", "Acceptance facility scheduling", "Error-free submission review"],
    link: "https://fastpassportcenter.com/checkout/",
  },
  {
    icon: "ri-search-eye-line",
    title: "Lost or Stolen Passport",
    description: "Casper travelers who have lost their passport can still get a replacement fast — we handle DS-64, DS-11, and the full submission process.",
    bullets: ["Form DS-64 prepared for you", "Replacement application reviewed", "Expedited processing available", "No DIY paperwork mistakes"],
    link: "https://fastpassportcenter.com/checkout/",
  },
  {
    icon: "ri-user-follow-line",
    title: "Child Passport — Casper",
    badge: "Under 16",
    description: "Minors require in-person application with both parents or a guardian. We guide Casper families through every parental consent requirement.",
    bullets: ["Both parents guidance", "Consent form DS-3053 prep", "Parental absence documentation", "Acceptance facility scheduling"],
    link: "https://fastpassportcenter.com/checkout/",
  },
  {
    icon: "ri-edit-line",
    title: "Name Change Passport",
    description: "Recently married or legally changed your name in Casper? We prepare DS-5504 or DS-82 and ensure your new name is reflected accurately.",
    bullets: ["Marriage or divorce name change", "Legal name change processing", "Document review for accuracy", "Expedited service available"],
    link: "https://fastpassportcenter.com/checkout/",
  },
  {
    icon: "ri-book-2-line",
    title: "Second Passport — Casper",
    description: "Frequent international travelers and Casper business professionals can apply for a second valid passport. We handle the full application.",
    bullets: ["For frequent travelers", "Active visa conflict situations", "Complete form DS-82 prep", "Professional document review"],
    link: "https://fastpassportcenter.com/checkout/",
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Our Services</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Services We Expedite for Casper Travelers
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you need a renewal, a first-time passport, or an emergency replacement — Fast Passport Center handles it with reserved courier submission availability.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <div
              key={i}
              className="group relative bg-white border border-gray-200 rounded-lg p-6 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
            >
              {service.badge && (
                <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                  {service.badge}
                </span>
              )}
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
                <i className={`${service.icon} text-[#1A365D] text-xl`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{service.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{service.description}</p>
              <ul className="space-y-1.5 mb-6 flex-1">
                {service.bullets.map((b, j) => (
                  <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                    {b}
                  </li>
                ))}
              </ul>
              <a
                href={service.link}
                className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap"
              >
                Get Started <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}